import { render, staticRenderFns } from "./user_info_edit.vue?vue&type=template&id=2ef5535a&scoped=true&"
import script from "./user_info_edit.vue?vue&type=script&lang=js&"
export * from "./user_info_edit.vue?vue&type=script&lang=js&"
import style0 from "./user_info_edit.vue?vue&type=style&index=0&id=2ef5535a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5535a",
  null
  
)

export default component.exports